import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonService from "../common/commonService";
import { API_URLS, STATUS_CODES } from "../common/constants";
import { toast } from "react-toastify";
import { startLoading, stopLoading } from "./commonSlice";

const initialState = {
  errorMessage: "",
  error: null,
  isEmployeesAdded: false,
  fileData: null,
};

export const addMultipleEmployees = createAsyncThunk(
  "multiple/employees",
  async (data, { rejectWithValue, dispatch }) => {
    dispatch(startLoading());
    const res = await commonService.postRequestForFormData(
      API_URLS.IMPORT_CSV,
      data
    );
    dispatch(stopLoading());
    if (res.statusCode !== STATUS_CODES.SUCCESS) {
      let msg = res.message;
      if (res.data) {
        msg += " (" + String(res.data) + ")";
      }
      toast.error(msg);
      return rejectWithValue(msg);
    }
    toast.success(res.message);
    return res;
  }
);

const multiEmployeeSlice = createSlice({
  name: "data",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addMultipleEmployees.pending, (state) => {
        return {
          ...state,
          error: null,
          isEmployeesAdded: false,
          fileData: null,
        };
      })
      .addCase(addMultipleEmployees.fulfilled, (state, action) => {
        return {
          ...state,
          error: false,
          isEmployeesAdded: true,
          fileData: action.payload.data,
        };
      })
      .addCase(addMultipleEmployees.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
          isEmployeesAdded: false,
          fileData: null,
        };
      });
  },
});

const { reducer } = multiEmployeeSlice;
export default reducer;
